import axios from "axios";

const domainConfigs = {
  nl: {
    importSampleBranch: "Amsterdam|Utrecht",
    supportedLanguages: ["EN", "NL"],
    defaultLanguage: "NL",
    showLanguageSwitcher: true,
    secureLoginLabels: {
      tab: "secureCodeLogin",
      sendButton: "sendSecureCode",
      heading: "enterSecureCode",
      subtitle: "secureCodeSent",
      hint: "sendASecureCode",
      resendToast: "codeSentAgain",
      sentTo: "enterCodeSentTo",
    },
    postcodeRegex: /^[0-9]{4}\s?[A-Za-z]{2}$/,
    postcodePlaceholder: "1234AB",
    mobilePlaceholder: "+31 612345678",
    streetPlaceholder:"Langestraat",
    cityPlaceholder: "Amsterdam",
    namePlaceholder: "Van der Berg B.V.",
    countries: [{ value: "Nederland", label: "netherlands", isoCode: "nl" }],
    defaultPhoneCountry: "nl",
    gatewayName: "Mollie",
    paymentRoute: "mollieRoute",
    financialLabels: {
      iban: "iban",                        
      ibanPlaceholder: "NL00 BANK 0000 0000 00",
      showIfsc: false,
      showAccount: false,     
      showGst: false,
      gAccount: "gAccount",               
      showGAccount: true, 
      showKvk: true,        
      vat: "vatNumber",                   
      currencySymbol: "€",
      currencyLocale: "nl-NL",
      costPlaceholder: "0,00",
      decimalSeparator: ",",
      currencyCode: "EUR",
      account: null,
      ifsc: null,
      gst: null,
      locationRequiredFieldsKey: "locationRequiredFields",
      locationOptionalFields: (t) => `${t("btwDetails")} ${t("and")} ${t("kvkDetails")}`,
      locationUpdateFieldsKey: "locationUpdateFieldsNL",
      relationProspectOptionalKey: "relationCreateProspectOptionalFields",
      showAsperionSection: true,
      showSimpleClientSection: false,
      vatPlaceholder: "NL123456789B01",
      cocNumberPlaceholder: "1234567890",
      gAccountPlaceholder: "NL91ABNA0417164300", 
      accountPlaceholder: null,
      gstPlaceholder: null, 
      ifscPlaceholder: null,
      serviceTaxRate: 0.0,
      vatRate: 0.0,
      serviceTaxLabel: "serviceTax",
      vatLabel: "vat",
    },
  },
  in: {
    importSampleBranch: "Mumbai|Pune",
    supportedLanguages: ["EN", "HI"],
    defaultLanguage: "EN",
    showLanguageSwitcher: true,
    secureLoginLabels: {
      tab: "secureOtpLogin",
      sendButton: "sendOtp",
      heading: "enterOtp",
      subtitle: "otpSentToEmail",
      hint: "sendAnOtp",
      resendToast: "otpSentAgain",
      sentTo: "enterOtpSentTo",
    },
    postcodeRegex: /^[0-9]{6}$/,
    postcodePlaceholder: "400001",
    mobilePlaceholder: "+91 9876543210",
    streetPlaceholder:"SVP Road",
    cityPlaceholder: "Mumbai",
    namePlaceholder: "Global Enterprises Pvt Ltd",
    countries: [{ value: "India", label: "india", isoCode: "in" }],
    defaultPhoneCountry: "in",
    gatewayName: "Razorpay",
    paymentRoute: "razorpayRoute",
    financialLabels: {
      account: "accountNumber",  
      showAccount: true,
      ifsc: "ifscCode",
      gst: "gstNumber",   
      showGst: true,         
      ibanPlaceholder: "",
      showIfsc: true,        
      showGAccount: false,
      showKvk: false,                    
      vat: "gstNumber",                   
      currencySymbol: "₹",
      currencyLocale: "en-IN",
      costPlaceholder: "0.00",
      decimalSeparator: ".",
      currencyCode: "INR",
      locationRequiredFieldsKey: "locationRequiredFieldsIN",
      locationOptionalFields: (t) => t("gstNumber"),
      locationUpdateFieldsKey: "locationUpdateFieldsIN",
      relationProspectOptionalKey: "relationCreateProspectOptionalFieldsIN",
      showAsperionSection: false,
      showSimpleClientSection: true,
      vatPlaceholder: null,
      cocNumberPlaceholder: null,   
      accountPlaceholder: "1234567890123456",       
      gstPlaceholder: "27ABCDE1234F1Z5",
      ifscPlaceholder: "SBIN0001234",
      serviceTaxRate: 0.0,
      vatRate: 0.0,
      serviceTaxLabel: "serviceTax",
      vatLabel: "gst",
    },
  },
};

const fallbackConfig = {
  supportedLanguages: ["EN"],
  defaultLanguage: "EN",
  showLanguageSwitcher: false,
  secureLoginLabels: {
    tab: "secureOtpLogin",
    sendButton: "sendOtp",
    heading: "enterOtp",
    subtitle: "otpSentToEmail",
    hint: "sendAnOtp",
    resendToast: "otpSentAgain",
    sentTo: "enterOtpSentTo",
  },
  postcodeRegex: /^[0-9]{6}$/,
  postcodePlaceholder: "400001",
  mobilePlaceholder: "+91 9876543210",
  cityPlaceholder: "Mumbai",
  streetPlaceholder:"SVP Road",
  namePlaceholder: "Global Enterprises Pvt Ltd",
  mobilePlaceholder: "9876543210", 
  countries: [{ value: "India", label: "india",  isoCode: "in" }],
  defaultPhoneCountry: "in",
  gatewayName: "Razorpay",
  paymentRoute: "razorpayRoute",
  financialLabels: {
    account: "accountNumber",
    ifsc: "ifscCode",
    gst: "gstNumber", 
    showGst: true,
    showIfsc: true,
    showGAccount: false,
    showKvk: false,
    vat: "gstNumber",
    currencySymbol: "₹",
    currencyLocale: "en-IN",
    costPlaceholder: "0.00",
    decimalSeparator: ".",
    currencyCode: "INR",
    ibanPlaceholder: "",
    locationRequiredFieldsKey: "locationRequiredFieldsIN",
    locationOptionalFields: (t) => t("gstNumber"),
    locationUpdateFieldsKey: "locationUpdateFieldsIN",
    relationProspectOptionalKey: "relationCreateProspectOptionalFieldsIN",
    showAsperionSection: false,
    showSimpleClientSection: true,
    vatPlaceholder: null,                
    cocNumberPlaceholder: null,   
    accountPlaceholder: "1234567890123456",      
    gstPlaceholder: "27ABCDE1234F1Z5",  
    ifscPlaceholder: "SBIN0001234",
    serviceTaxRate: 0.0,
    vatRate: 0.0,
    serviceTaxLabel: "serviceTax",
    vatLabel: "gst",
  },
};

let activeTld = null;

export const initDomainConfig = async () => {
  activeTld = await fetchTldFromApi();
};

export const refreshDomainConfig = async () => {
  activeTld = await fetchTldFromApi();
};

const fetchTldFromApi = async () => {
  try {
    const resp = await axios.get(
      `${process.env.REACT_APP_API_URL}/business/configRoute/admin/getActiveDomain`,
      { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
    );
    return resp.data?.tld || null;
  } catch {
    return null;
  }
};

export const getDomainConfig = () => {
  const tld = activeTld ?? 'in';
  return domainConfigs[tld] || fallbackConfig;
};

export const getAvailableDomains = () => Object.keys(domainConfigs);